import React from "react";
import PageNotFound from "../assets/images/Pagenotfound.png"

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <img
        src={PageNotFound}
        alt="Page Not Found"
        style={{ maxWidth: "400px", width: "100%", marginBottom: "20px" }}
      />

      <h2 style={{ fontWeight: "600" }}>Page Not Found</h2>
      <p style={{ color: "#6c757d" }}>
        The page you are looking for doesn’t exist or has been moved.
      </p>
    </div>
  );
};

export default NotFound;
